module.exports = __webpack_public_path__ + "img/u76.12586a4f.png";